import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import {on, debounce, Options} from "../utils/decorators";


@Options({
    template: false,
    ui: {
        sitesMenu:           "[data-js-ui=sites-menu]",
        menuItem:            "[data-js-ui=mobile-menu-item]",
        closeMenuBtn:        "[data-js-ui=close-menu-btn]",
        toggleSitesBtn:      "[data-js-ui=toggle-sites-btn]",
        toggleSubMenuBtn:    "[data-js-ui=mobile-menu-item] a.mobile-menu__link",
    }
})
export default class SiteHeaderMobileView extends Marionette.View<Backbone.Model>{

    _siteMenuOpenClass = "is-open-sites";

    @on("click @ui.closeMenuBtn")
    onCloseMenuBtnClick() {
        this.$el.removeClass("is-open is-open-sites");
        $('.search-results__header').addClass('is-visible');
        $('body').removeClass('nav-open');
    }

    @on("click @ui.toggleSitesBtn")
    onToggleSitesBtnClick() {
        this.$el.toggleClass(this._siteMenuOpenClass);
        if (this.$el.hasClass(this._siteMenuOpenClass)) {
            this.ui.sitesMenu.slideDown();
        } else {
            this.ui.sitesMenu.slideUp();
        }
    }

    @on("click @ui.toggleSubMenuBtn")
    onToggleSubMenuBtnClick(e) {
        const $target = $(e.currentTarget);
        const $parent = $target.closest(this.ui.menuItem);
        e.preventDefault();

        this.ui.menuItem.not($parent).removeClass("is-expanded");
        $parent.toggleClass("is-expanded");

        let openIndex = $parent.data('menu-index');
        if($parent.hasClass('is-expanded')) {
            window.sessionStorage.setItem('open-mobile-menu-item', openIndex);
        } else {
            window.sessionStorage.setItem('open-mobile-menu-item', null);
        }
    }

    onRender() {
        let openIndex = window.sessionStorage.getItem('open-mobile-menu-item');
        if(openIndex) {
            $(`[data-menu-index="${openIndex}"]`).addClass('is-expanded');
        }
    }
}



// WEBPACK FOOTER //
// ./@modules/views/site-header-mobile-view.ts